<template>
    <svg fill="#28b676" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
            <g data-name="Layer 2">
                <g data-name="checkmark-square-2">
                    <rect width="24" height="24" transform="rotate(180 12 12)" opacity="0"></rect>
                    <path
                    d="M18 3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm-1.7 6.61l-4.57 6a1 1 0 0 1-.79.39 1 1 0 0 1-.79-.38l-2.44-3.11a1 1 0 0 1 1.58-1.23l1.63 2.08 3.78-5a1 1 0 1 1 1.6 1.22z">
                </path>
            </g>
        </g>
    </g>
</svg></template>
<script>
export default {
    name: 'check_filled',
}
</script>